import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from 'common/react/components/SvgIcon';
import { TooltipButton } from 'common/react/components/tooltip-button';
import { getTranslation } from 'common/react/utils/translations';
import { useSelector } from 'react-redux';
import { playerModalSelector } from 'common/store/modules/player-awards/player-modal/selectors';
import { RoundVotesTable } from './round-votes';
import { SeasonContext } from '../../Leaderboard/components/table/LeaderboardTableFetcher';
import { useGetRoundsQuery } from 'common/store/modules/api/afl-api';

/**
 * Renders bottom section of the Brownlow Player Modal
 * with round by round votes table
 *
 * @param root0
 * @param root0.playerName
 * @returns {HTMLElement}
 */
export const PlayerModalRoundByRound = ({ playerName }) => {
    const modal = useSelector(playerModalSelector);

    const { data: rounds } = useGetRoundsQuery(
        {
            compseasonId: modal.seasonId,
            params: {
                pageSize: 50
            }
        },
        { skip: !modal.seasonId }
    );

    return (
        <div className="player-awards-player-modal__round-by-round">
            <div className="player-awards-player-modal__round-by-round-header">
                <span className="player-awards-player-modal__label player-awards-player-modal__label--full-width-mobile">
                    {getTranslation('label.brownlow.tracker.roundByRound')}
                </span>

                <TooltipButton
                    id="player-awards-player-modal-tooltip"
                    title="Select a round to view details"
                    classNames={{
                        component: 'player-awards-player-modal-tooltip',
                        button: 'player-awards-player-modal-tooltip__button'
                    }}
                    direction="below"
                    primaryTooltipContent={
                        <div className="player-awards-player-modal-tooltip__content">
                            {getTranslation(
                                'label.brownlow.tracker.tooltipContent'
                            )}
                        </div>
                    }
                >
                    <SvgIcon
                        icon="info"
                        className="player-awards-player-modal-tooltip__icon"
                    />
                    {getTranslation('label.brownlow.tracker.tooltipTargetText')}
                </TooltipButton>
            </div>
            <div className="player-awards-player-modal__round-by-round-content">
                <SeasonContext.Provider value={{ id: modal.seasonId }}>
                    <RoundVotesTable
                        rounds={rounds ?? []}
                        tooltips={true}
                        playerName={playerName}
                    />
                </SeasonContext.Provider>
            </div>
        </div>
    );
};

PlayerModalRoundByRound.propTypes = {
    playerName: PropTypes.string
};
